import React from 'react';

import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import './TypingIndicator.scss';

export const TypingIndicator: React.FC = () => {
    return (
        <Row alignmentHorizontal="start">
            <Text>AI is thinking</Text>
            <div style={{ display: 'flex', gap: '4px' }}>
                <div
                    style={{
                        width: '6px',
                        height: '6px',
                        backgroundColor: '#666',
                        borderRadius: '50%',
                        animation: 'typing-bounce 1.4s infinite ease-in-out',
                        animationDelay: '-0.32s'
                    }}
                />
                <div
                    style={{
                        width: '6px',
                        height: '6px',
                        backgroundColor: '#666',
                        borderRadius: '50%',
                        animation: 'typing-bounce 1.4s infinite ease-in-out',
                        animationDelay: '-0.16s'
                    }}
                />
                <div
                    style={{
                        width: '6px',
                        height: '6px',
                        backgroundColor: '#666',
                        borderRadius: '50%',
                        animation: 'typing-bounce 1.4s infinite ease-in-out',
                        animationDelay: '0s'
                    }}
                />
            </div>
        </Row>
    );
};
